import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {Badge} from '@mantine/core';
import {AiOutlineFilter} from 'react-icons/ai';
import {FlexiButton} from '@flexinet/ui-components';

import {useCertificatesFilter} from '../hooks/useCertificatesQuery';
import {FilterDrawer} from '../drawers/FilterDrawer';

// Reads the module-scoped store directly, which is the whole reason that store
// exists — the button, the drawer and the list hook are three different
// components.
//
// ⚠️ THE FILTER IS NOT A WRITE CONTROL and is NOT hidden for a read-only
// tenant. Finding the certificate that is stuck is exactly what a read-only
// credential is for; hiding the filter would remove this module's most useful
// read affordance from the tenants most likely to need it.
export const FilterCertificatesButton = () => {

    const [opened, setOpened] = useState(false);
    const {filters} = useCertificatesFilter();

    // Empty values are never stored (see FilterForm), so a key present here is
    // a filter genuinely narrowing the table.
    const activeCount = Object.keys(filters).length;

    return (
        <>
            <div style={{position: 'relative'}}>
                <FlexiButton
                    leftSection={<AiOutlineFilter/>}
                    onClick={() => setOpened(true)}
                >
                    {I18n.get('Filter')}
                </FlexiButton>
                {activeCount > 0 && (
                    <Badge
                        size={'xs'}
                        variant={'filled'}
                        color={'blue'}
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                    >
                        {activeCount}
                    </Badge>
                )}
            </div>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
